module.exports = __webpack_public_path__ + "img/take_off.f660f292.svg";